import { render, staticRenderFns } from "./ScreenReaderButton.vue?vue&type=template&id=0478f340&scoped=true&"
import script from "./ScreenReaderButton.vue?vue&type=script&lang=js&"
export * from "./ScreenReaderButton.vue?vue&type=script&lang=js&"
import style0 from "./ScreenReaderButton.vue?vue&type=style&index=0&id=0478f340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478f340",
  null
  
)

export default component.exports